import {Injectable} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {ToasterService} from "angular2-toaster";

/**
 *  Service permettant de mettre en commun des fonctions utilisées dans toute l'application
 */
@Injectable()
export class SproToasterService {

  /** Message pour l'affichage dans les toasters */
  public w_toasterTradMessage: string;

  /**
   * Constructeur
   */
  constructor( public s_translate: TranslateService,
    public s_toaster: ToasterService) {}

  /**
   * Fonction d'affichage de notification en cas d'erreur
   * Parametres : Code de traduction de l'erreur a afficher
   */
  public proc_toastTradError(codeTraduction: string) {
    this.s_translate.get(codeTraduction).subscribe((toasterTradMessage) => {this.w_toasterTradMessage = toasterTradMessage});
    setTimeout(() => this.s_toaster.pop("error", "", this.w_toasterTradMessage));
  }

  /**
   * Fonction d'affichage de notification en cas de succes
   * Parametres : Code de traduction du message a afficher
   */
  public proc_toastTradSuccess(codeTraduction: string) {
    this.s_translate.get(codeTraduction).subscribe((toasterTradMessage) => {this.w_toasterTradMessage = toasterTradMessage});
    setTimeout(() => this.s_toaster.pop("success", "", this.w_toasterTradMessage));
  }

  /**
   * Fonction d'affichage de notification en cas de warning
   * Parametres : Code de traduction du message a afficher
   */
  public proc_toastTradWarning(codeTraduction: string) {
    this.s_translate.get(codeTraduction).subscribe((toasterTradMessage) => {this.w_toasterTradMessage = toasterTradMessage});
    setTimeout(() => this.s_toaster.pop("warning", "", this.w_toasterTradMessage));
  }

} 



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/services/spro-toaster/spro-toaster.service.ts